module.exports = __webpack_public_path__ + "static/media/battles-splash-logo.b2663b7f.png";